import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { Link } from "react-scroll";
import hamburger from "../images/icons/bars-solid.svg";
import logo from '../images/logo.jpg';
import "../variables.css";

const MobileMenu = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false)

  return (
    <>
    <nav className="navigation">
      <div className="hamburger" onClick={() => { setIsNavExpanded(!isNavExpanded)}}>
        <img src={hamburger} alt="Menu"></img>
      </div>    
      <div
        className={ isNavExpanded ? "navigation-menu expanded" : "navigation-menu"}
        >
        <ul>
          <NavLink to="/" onClick={() => { setIsNavExpanded(!isNavExpanded)}} >Strona Główna</NavLink>
          <NavLink to="/omnie" onClick={() => { setIsNavExpanded(!isNavExpanded)}} >O Mnie</NavLink>
          <Link to="oferta" onClick={() => { setIsNavExpanded(!isNavExpanded)}} activeClass="active" spy={true} smooth={true} offset={50} duration={500}>Oferta</Link>
          <Link to="kontakt" onClick={() => { setIsNavExpanded(!isNavExpanded)}} activeClass="active" spy={true} smooth={true} offset={50} duration={500}>Kotakt</Link>
          <NavLink to="/projekt" onClick={() => { setIsNavExpanded(!isNavExpanded)}}>Dofinansowanie</NavLink>
        </ul>  
      </div>
    </nav>
    <div className="navigation-box">
      <a href="/" className="brand-name" >
        <img src={logo} alt="Zacisze Piękna"></img>
      </a>
    </div>
  </>  
);
}

export default MobileMenu;
